import React from "react";

const ClientPing = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path
            fill={fill || "#9A5BFF"}
            stroke="#fff"
            strokeWidth={0.811}
            d="M17.707 33.405c1.594 0 3.052-.184 4.125-.49.533-.153.995-.342 1.332-.57.323-.218.624-.537.624-.967 0-.43-.301-.749-.624-.967-.337-.228-.799-.417-1.332-.57-1.073-.306-2.53-.49-4.125-.49-1.594 0-3.052.184-4.125.49-.533.153-.994.342-1.331.57-.323.218-.625.538-.625.967 0 .43.302.75.625.968.337.227.798.416 1.332.569 1.072.306 2.53.49 4.124.49Z"
        />
        <path
            fill="#fff"
            stroke="#C8CBD8"
            strokeWidth={0.788}
            d="m25.69 22.903-8.08 8.08-8.08-8.08c-4.464-4.463-4.464-11.699 0-16.162 4.462-4.463 11.698-4.463 16.16 0 4.463 4.463 4.463 11.699 0 16.162Z"
        />
        <path
            fill={fill || "#9A5BFF"}
            d="M27.27 14.61a9.66 9.66 0 1 1-19.322 0c.001-5.335 4.326-9.66 9.662-9.66 5.335 0 9.66 4.325 9.66 9.66Z"
        />
        <path
            fill="#fff"
            d="M12.864 20.938c0-1.279.5-2.505 1.39-3.41a4.709 4.709 0 0 1 3.356-1.411c1.259 0 2.466.508 3.356 1.412a4.86 4.86 0 0 1 1.39 3.409h-9.492Zm4.746-5.424c-1.966 0-3.56-1.618-3.56-3.616 0-1.997 1.593-3.616 3.56-3.616 1.966 0 3.56 1.619 3.56 3.616 0 1.998-1.594 3.616-3.56 3.616Z"
        />
    </svg>
);

export default ClientPing;
